import { writable } from 'svelte/store';
import en from './edited/en';
import tr from './edited/tr';
// Flatten nested structure
const flattenTranslations = (obj, prefix = '') => {
    let result = Object.entries(obj).reduce((acc, [key, value]) => {
        const newKey = prefix ? `${prefix}.${key}` : key;
        if (typeof value === 'object') {
            return { ...acc, ...flattenTranslations(value, newKey) };
        }
        return { ...acc, [newKey]: value };
    }, {});
    return result;
};
export const translations = writable(flattenTranslations(en));
// Async loader for each language
const asyncTranslations = {
    cs: () => import('./edited/cs'),
    id: () => import('./edited/id'),
    ar: () => import('./edited/ar'),
    vi: () => import('./edited/vi'),
    ms: () => import('./edited/ms'),
    de: () => import('./edited/de'),
    es: () => import('./edited/es'),
    fr: () => import('./edited/fr'),
    it: () => import('./edited/it'),
    ja: () => import('./edited/ja'),
    ko: () => import('./edited/ko'),
    pt: () => import('./edited/pt'),
    ru: () => import('./edited/ru'),
    tr: () => import('./edited/tr'),
    th: () => import('./edited/th'),
    zh: () => import('./edited/zh')
};
export async function loadTranslation(lang) {
    if (lang === 'en') {
        translations.set(flattenTranslations(en));
        return;
    }
    try {
        const module = await asyncTranslations[lang]();
        translations.set(flattenTranslations(module.default));
    }
    catch (error) {
        console.error(`Failed to load translations for ${lang}`, error);
        // Fallback to English if load fails
        translations.set(flattenTranslations(en));
    }
}
